import {
    SET_USER,
    SET_ERROR,
    SET_LOADING,
    SET_VOCAB,
    SET_QUEUE,
    SET_PRACTICE_QUEUE,
    SET_ACTIVE_QUEUE,
    SET_LESSONS,
} from './mutation-types'
const mutations = {
    [SET_USER](state, payload) {
        state.user = payload
    },
    [SET_ERROR](state, payload) {
        state.error = payload
    },
    [SET_LOADING](state, payload) {
        state.loading = payload
    },
    [SET_VOCAB](state, payload) {
        state.vocabulary = payload
    },
    [SET_QUEUE](state, payload) {
        state.queue = payload
    },
    [SET_PRACTICE_QUEUE](state, payload) {
        state.practiceQueue = payload
    },
    [SET_ACTIVE_QUEUE](state, payload) {
        state.activeQueue = payload
    },
    enqueue(state, payload) {
        state.queue.push(payload)
    },
    [SET_LESSONS](state, payload) {
        state.lessons = payload
    },
    setLessonFinished(state) {
        state.user.lessonReviewed = true
    },
    srsLevelUp(state, payload) {
        var toUpdate = state.queue.find(word => word.id === payload.id)
        toUpdate.srs = payload.srs
        toUpdate.lastChange = payload.lastChange
    },
    userLevelUp(state, payload) {
        state.user.currentLesson = payload
        state.user.lessonReviewed = false
    },
    setImages(state, payload) {
        state.images = payload
    },
    addLessonQuestionsToQueue(state, payload) {
        for (var q in payload) {
            state.queue.push(q)
        }
    },
    setFMQuestions(state, payload) {
        state.fmquestions = payload
    },
    setVerbQuestions(state, payload) {
        state.verbQuestions = payload
    },
    setVerbQuestionTypes(state, payload) {
        state.verbQuestionTypes = payload
    },
    setPaleoQuestions(state, payload) {
        state.paleoQuestions = payload
    },
    setPrimerData(state, payload) {
        state.primerData = payload
    },
    setPaleoImage(state, payload) {
        state.paleoImage = payload;
    },
    addPaleoImage(state, payload) {
        state.paleoImages.push(payload);
    },
    setPrimerImages(state, payload) {
        if (state.primerImages.indexOf(payload) < 0) { state.primerImages.push(payload); }
    }
};

export default mutations;